<template>
  <div class="fixed inset-0 flex items-center justify-center bg-white">
    <span class="absolute right-0 top-0 m-4">
      <CloseBtn />
    </span>

    <div class="w-full max-w-[550px] p-4 text-center">
      <AlertSuccess v-if="isSuccess" />
      <AlertAwaiting v-if="isAwaiting" />
      <AlertSpamming v-if="isSpamming" />
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { ALERTS, useMainStore } from '@/apps/fast/store'

import AlertSuccess from './AlertSuccess.vue'
import AlertAwaiting from './AlertAwaiting.vue'
import AlertSpamming from './AlertSpamming.vue'

import CloseBtn from './CloseBtn.vue'

export default {
  components: {
    CloseBtn,
    AlertSuccess,
    AlertAwaiting,
    AlertSpamming
  },
  computed: {
    ...mapStores(useMainStore),
    isSuccess() {
      return this.mainStore.alert === ALERTS.success
    },
    isAwaiting() {
      return this.mainStore.alert === ALERTS.awaiting
    },
    isSpamming() {
      return this.mainStore.alert === ALERTS.spamming
    }
  }
}
</script>
